export const theme = () => {
    let btns = document.querySelectorAll(".header__theme");
    let siteContainer = document.querySelector('.site-container');
    let preloader = document.querySelector('.preloader');
    let ageCheck = document.querySelector(".agecheck");
    let cookies = document.querySelector(".cookies");
    let isDarkTheme = getCookie('theme') === 'dark';
    let date = new Date();


    if (isDarkTheme) {
        siteContainer.classList.add('dark');
        preloader.classList.add('dark');
        ageCheck.classList.add('dark');
        cookies.classList.add('dark');
    }

  
    if ( getCookie('manualTheme') != "true" ) {
        console.log( getCookie('manualTheme') );
        if ( date.getHours() >= 17 || date.getHours() < 9 ) {
            siteContainer.classList.add('dark');
            preloader.classList.add('dark');
            ageCheck.classList.add('dark');
            cookies.classList.add('dark');
        } else {
            siteContainer.classList.remove('dark');
            preloader.classList.remove('dark');
            ageCheck.classList.remove('dark');
            cookies.classList.remove('dark');
        }
    }
    

    btns.forEach(btn => {
        btn.addEventListener('click', () => {
            document.cookie = 'manualTheme=true'
            if (siteContainer.classList.contains('dark')) {
                siteContainer.classList.remove('dark');
                preloader.classList.remove('dark');
                ageCheck.classList.remove('dark');
                cookies.classList.remove('dark');
                document.cookie = "theme=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            } else {
                siteContainer.classList.add('dark');
                preloader.classList.add('dark');
                ageCheck.classList.add('dark');
                cookies.classList.add('dark');
                document.cookie = "theme=dark; expires=Fri, 31 Dec 9999 23:59:59 UTC; path=/;";
            }
        })
    });
};

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
